export default "__VITE_PUBLIC_ASSET__eb37b67f__"